import { render, staticRenderFns } from "./dataServiceMonitoring.vue?vue&type=template&id=647f1c6b&scoped=true"
import script from "./dataServiceMonitoring.vue?vue&type=script&lang=js"
export * from "./dataServiceMonitoring.vue?vue&type=script&lang=js"
import style0 from "./dataServiceMonitoring.vue?vue&type=style&index=0&id=647f1c6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647f1c6b",
  null
  
)

export default component.exports